import React from 'react';
import Slider from 'react-slick';
import 'slick-carousel/slick/slick.css';
import 'slick-carousel/slick/slick-theme.css';

interface IProps {
  customSetting?: any;
  children: React.ReactNode;
}

const Carousel = ({ customSetting, children }: IProps) => {
  // https://react-slick.neostack.com/docs/api
  const settings = {
    dots: true,
    infinite: true,
    arrows: false,
    autoplay: true,
    autoplaySpeed: 3000,
    speed: 500,
    ...customSetting
  };

  return (
    <Slider {...settings}>
      {children}
    </Slider>
  );
}

export default Carousel;
